import { useEffect, useImperativeHandle } from 'react';
import { TpaGalleryProps as TPAGalleryPropsPlatform } from '@wix/thunderbolt-components-native';
import { useIFrame } from '../useIFrame/useIFrame';
import { TPAGalleryRef } from '../../components/TPAGallery/TPAGallery.types';

type TPAGaleryConfig = Pick<
  TPAGalleryPropsPlatform,
  | 'componentReady'
  | 'compProps'
  | 'compStyles'
  | 'quality'
  | 'images'
  | 'mainPageId'
>;

export function useTPAGallery(
  compRef: TPAGalleryRef,
  {
    componentReady,
    compProps,
    compStyles,
    quality,
    images,
    mainPageId,
  }: TPAGaleryConfig,
): (node: HTMLIFrameElement) => void {
  const [ref, sendMessage] = useIFrame({ iframeLoaded: componentReady });

  useImperativeHandle(compRef, () => {
    return {
      next: () => {
        sendMessage(
          JSON.stringify({
            params: { cmd: 'next' },
            eventType: 'SETTINGS_UPDATED',
            intent: 'addEventListener',
          }),
        );
      },
      previous: () => {
        sendMessage(
          JSON.stringify({
            params: { cmd: 'previous' },
            eventType: 'SETTINGS_UPDATED',
            intent: 'addEventListener',
          }),
        );
      },
    };
  });

  useEffect(() => {
    if (componentReady) {
      sendMessage(
        JSON.stringify({
          params: {
            props: { ...compProps, ...compStyles },
            quality,
            marketingLandingPage: false,
            items: images,
            mainPageId,
          },
          eventType: 'SETTINGS_UPDATED',
          intent: 'addEventListener',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [componentReady, images, compProps]);

  return ref;
}
